
import React from 'react'
import Calender from "../components/Calender";
function Reservation() {
  return (
    <div className=' bg-[#fbf8f5]'>
        <Calender/>
    
    </div>
  )
}

export default Reservation